import Quill from 'quill';

const Parchment = Quill.import('parchment');

class FontFamilyAttributor extends Parchment.Attributor.Style {
  value(node) {
    return super.value(node).replace(/["']/g, '');
  }
}

const FontFamily = new FontFamilyAttributor('customFontFamily', 'font-family', {
  scope: Parchment.Scope.INLINE,
});

export default FontFamily;
